module.exports = __webpack_public_path__ + "media/images/favicon-3fc507209823952fd87815fa565b5561.ico";